export enum EnumHomeWorkStatus {
    Done = "Done",
    NotDoing = "NotDoing",
}

export const EnumHomeWorkStatusToString = {
    Done: "🟢 Đã làm",
    NotDoing: "🔴 Chưa làm",
} as any